<template>
	<drawer
			title="Add note"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				margin="0"
				width="300px"
				min-height="54px"
				label="Note"
				placeholder="Enter note"
				:setInputValue="notes"
				@updateInput="onInput"
				is-textarea
		></field>
	</drawer>
</template>

<script>

import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "NotesDrawer",
	components: { Drawer },
	props: {
		createBy: String,
		editItem: Object
	},
	data: () => ({
		drawer: true,
		notes: '',
		id: null
	}),
	methods: {
		onClose() {
			this.$emit('closeDrawer');
		},
		onInput({ value }) {
			this.notes = value;
		},
		onSave() {
			const values = {
				notes: this.notes,
				id: this.id
			};

			this.$emit('updateSave', values);
		}
	},
	mounted() {
		if (this.editItem) {
			const { notes, id } = this.editItem;
			this.notes = notes;
			this.id = id;
		}
	}
};
</script>
